import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '@clerk/clerk-react';
import axios from '../config/api';

interface CreditsState {
  credits: number | null;
  costPerAnalysis: number;
  isLoading: boolean;
  refresh: () => void;
}

export const useCredits = (): CreditsState => {
  const [credits, setCredits] = useState<number | null>(null);
  const [costPerAnalysis, setCostPerAnalysis] = useState<number>(1);
  const [isLoading, setIsLoading] = useState(true);
  const { getToken, isSignedIn, isLoaded } = useAuth();

  const fetchCredits = useCallback(async () => {
    if (!isLoaded || !isSignedIn) {
      setCredits(null);
      setIsLoading(false);
      return;
    }

    try {
      const token = await getToken();
      if (!token) return;

      const response = await axios.get('/api/credits', {
        headers: { Authorization: `Bearer ${token}` },
      });

      setCredits(response.data.credits);
      setCostPerAnalysis(response.data.cost_per_analysis);
    } catch (error) {
      console.error('Failed to fetch credits:', error);
    } finally {
      setIsLoading(false);
    }
  }, [getToken, isSignedIn, isLoaded]);

  useEffect(() => {
    fetchCredits();
  }, [fetchCredits]);

  return {
    credits,
    costPerAnalysis,
    isLoading,
    refresh: fetchCredits,
  };
};
